

const Four04=()=>{
    return <h1 id='error'>404! Address not found!</h1>
}

export default Four04